import Router from 'next/router'

import excludeBlankKeys from '@/helpers/excludeBlankKeys'

import getFilters from './functions/getFilters'
import stringify from './functions/stringify'

class Filters {
  private static apply(ids: (number | string)[], category: string) {
    const currentFilters = this.get()
    const filters = stringify({ ...currentFilters, [category]: ids })
    const query = excludeBlankKeys<string>({
      ...Router.query,
      filters,
      page: null,
    })

    Router.push({ query }, undefined, { shallow: true })
  }

  static get(category?: string) {
    if (Router.router?.isReady) {
      const filters = Router.query.filters?.toString()
      if (filters) {
        return getFilters(filters, category)
      }
    }
  }

  static add(id: number | string, category: string) {
    const categoryFilters = (Filters.get(category) as number[]) || []
    const newFilters = [...new Set([...categoryFilters, id])]

    return this.apply(newFilters, category)
  }

  static remove(id: number | string, category: string) {
    const categoryFilters = (Filters.get(category) as number[]) || []
    const newFilters = categoryFilters.filter((number) => number !== id)
    return this.apply(newFilters, category)
  }
}

export default Filters
